import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, isDevMode, NgModule } from "@angular/core";
import { RouterModule, NavigationEnd, Router } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { datadogRum } from "@datadog/browser-rum";
import { filter } from "rxjs/operators";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { SharedModule } from "./shared/shared.module";
import { AuthInterceptor } from "./services/auth.interceptor";
import { LandingComponent } from "./landing/landing.component";
import { ToastModule } from "primeng/toast";
import { MultiSelectModule } from "primeng/multiselect";
import { UnauthorizedPageComponent } from "./unauthorized/unauthorized.component";
import { DatadogRumService } from "./services/datadog-rum.service";
import { environment } from "../environments/environment";
import { StateService } from "./services/state.service";
import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LandingComponent,
    UnauthorizedPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(
      {},
      {
        metaReducers: [],
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      },
    ),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 50, logOnly: !isDevMode() }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedModule,
    HttpClientModule,
    ToastModule,
    MultiSelectModule,
    RouterModule.forRoot([]),
    LottieComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideLottieOptions({
      player: () => player,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    router: Router,
    private readonly datadogRumService: DatadogRumService,
    private readonly stateService: StateService,
  ) {
    if (environment.production) {
      router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          datadogRum.addAction("Navigation", { path: event.urlAfterRedirects });
          datadogRum.startView(event.urlAfterRedirects);
        });
      this.datadogRumService.setUser();
    }
  }
}
